/**
 * Marquee — a small horizontal running ticker (DS core). Renders `children` twice
 * for a seamless −50% loop, with edge fade and pause-on-hover (uses the shared
 * `.ds-ticker` keyframes in index.css). For pill rows, stat strips, etc.
 * Optional `durationSec` (loop time — bigger = slower) and `reverse` (run the
 * other way) override the defaults via inline style on the track.
 */
import type { CSSProperties, ReactNode } from "react";

export function Marquee({
  children, className = "", durationSec, reverse = false,
}: {
  children: ReactNode;
  className?: string;
  durationSec?: number;
  reverse?: boolean;
}) {
  const trackStyle: CSSProperties = {};
  if (durationSec) trackStyle.animationDuration = `${durationSec}s`;
  if (reverse) trackStyle.animationDirection = "reverse";
  return (
    <div className={`ds-ticker overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_9%,black_91%,transparent)] ${className}`}>
      <div className="ds-ticker-track flex w-max" style={trackStyle}>
        {[0, 1].map((dup) => (
          <div key={dup} className="flex shrink-0 items-center gap-2 pl-2" aria-hidden={dup === 1}>
            {children}
          </div>
        ))}
      </div>
    </div>
  );
}
